import { render, staticRenderFns } from "./NewMaterials.vue?vue&type=template&id=ac0217ce&scoped=true"
import script from "./NewMaterials.vue?vue&type=script&lang=js"
export * from "./NewMaterials.vue?vue&type=script&lang=js"
import style0 from "./NewMaterials.vue?vue&type=style&index=0&id=ac0217ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac0217ce",
  null
  
)

export default component.exports